export const PREBUILT_GROUPS = {
    ADMIN: 'Admin',
}
